import Blazy from 'blazy';
import _u from '../utils';
import {disableHtmlScrollMixin} from '../../components/mixins/component-mixins';

const initDirectives = (app) => {
    app.directive('click-outside', {
        beforeMount(el, binding, _vNode) {
            el.clickOutsideEvent = function(event) {
                if (el !== event.target && !el.contains(event.target)) {
                    binding.value(event, el);
                }
            };
            document.body.addEventListener('click', el.clickOutsideEvent);
        },
        unmounted(el) {
            document.body.removeEventListener('click', el.clickOutsideEvent);
        },
    });

    app.directive('max-length', {
        beforeMount(el, binding, _vnode) {
            el.dataset.maxLength = Number(binding.value);
            const handler = function(e) {
                if (e.target.value.length > el.dataset.maxLength) {
                    e.target.value = e.target.value.substring(0, el.dataset.maxLength);
                    const event = new Event('input', {
                        'bubbles': true,
                        'cancelable': true,
                    });
                    dispatchEvent(event);
                }
            };
            el.addEventListener('input', handler);
        },
        updated(el, binding, _vnode) {
            el.dataset.maxLength = Number(binding.value);
        },
    });

    app.directive('text-exist', {
        beforeMount(el, binding) {
            if (binding.value && binding.value !== '') {
                el.textContent = binding.value;
            }
        },
        updated(el, binding) {
            if (binding.value && binding.value !== '') {
                el.textContent = binding.value;
            }
        },
    });

    app.directive('disable-body-scroll', {
        beforeMount(el, binding) {
            disableHtmlScrollMixin.methods._disableScroll(binding.value, el);
            el.disabledScroll = binding.value;
        },
        updated(el, binding) {
            if (el.disabledScroll !== binding.value) {
                disableHtmlScrollMixin.methods._disableScroll(binding.value, el);
                el.disabledScroll = binding.value;
            }
        },
        unmounted(el) {
            disableHtmlScrollMixin.methods._disableScroll(false, el);
            el.disabledScroll = false;
        },
    });

    function initLazyLoad(container, placeholderSrc) {
        container.dataset.lazyLoad = _u.genUid();
        new Blazy({
            selector: '.b-lazy[data-src]',
            container: `[data-lazy-load='${container.dataset.lazyLoad}']`,
            offset: 500,
            error(element, message) {
                if (message === 'invalid') { // data-src is invalid
                    element.src = placeholderSrc;
                }
            },
        });
    }

    app.directive('lazy-load', {
        beforeMount(el, binding) {
            initLazyLoad(el, binding.value);
        },
        updated(el, binding) {
            const nestedElements = el.getElementsByTagName('img');
            for (let i = 0; i < nestedElements.length; i++) {
                const element = nestedElements[i];
                element.classList.remove('b-loaded');
                element.classList.remove('b-error');
            }
            initLazyLoad(el, binding.value);
        },
    });
};

export default initDirectives;
